import {NgModule} from "@angular/core";
import {UserProfileCompletionPageComponent} from "./user-profile-completion-page/user-profile-completion-page.component";
import {UserProfileSetupPageComponent} from "./user-profile-setup-page/user-profile-setup-page.component";
import {UserProfileChromeControlComponent} from "./user-profile-chrome-control/user-profile-chrome-control.component";
import {SharedModule} from "../shared/shared.module";
import {LoginModule} from "../login/login.module";

@NgModule({
    imports: [
        SharedModule,
        LoginModule
    ],
    declarations: [
        UserProfileChromeControlComponent,
        UserProfileCompletionPageComponent,
        UserProfileSetupPageComponent
    ],
    exports: [
        UserProfileChromeControlComponent,
        UserProfileCompletionPageComponent,
        UserProfileSetupPageComponent
    ]
})
export class UserProfileModule {

}
